
var phoenixTag = phoenixTag || {};

phoenixTag.header = phoenixTag.header || function ($) {

    function mobileNav(callback) {

        var offcanvas = $('.offcanvas');
        var mobileNavTrigger = $('.mobile-toggle-btn');


        $(mobileNavTrigger).click(function() {
            $(offcanvas).toggleClass("offcanvas--active");
            $(mobileNavTrigger).toggleClass("mobile-toggle-btn--active");
        });


    }

    // public functions:
    return {
        mobileNav: mobileNav

    };

} (jQuery);